import React, { useState, useEffect } from 'react';
import Layout from '@/components/Layout';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { newsletterApi } from '@/lib/api';
import { MailX, CheckCircle } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';

const UnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const [status, setStatus] = useState('pending');

  const handleUnsubscribe = async () => {
    if (!email) return;
    try {
      await newsletterApi.unsubscribe(email);
      setStatus('done');
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <Layout>
      <section className="py-20 bg-stone-50 min-h-[60vh] flex items-center">
        <div className="max-w-md mx-auto px-4">
          <Card>
            <CardContent className="p-8 text-center">
              {status === 'done' ? (
                <>
                  <CheckCircle className="h-12 w-12 text-green-600 mx-auto mb-4" />
                  <h2 className="text-xl font-semibold text-stone-800 mb-2">Unsubscribed</h2>
                  <p className="text-stone-600">
                    <strong>{email}</strong> has been removed from our newsletter list. You will no longer receive emails from us.
                  </p>
                </>
              ) : status === 'error' ? (
                <>
                  <MailX className="h-12 w-12 text-red-500 mx-auto mb-4" />
                  <h2 className="text-xl font-semibold text-stone-800 mb-2">Something went wrong</h2>
                  <p className="text-stone-600">Please try again or contact us directly.</p>
                </>
              ) : (
                <>
                  <MailX className="h-12 w-12 text-stone-400 mx-auto mb-4" />
                  <h2 className="text-xl font-semibold text-stone-800 mb-2">Unsubscribe</h2>
                  <p className="text-stone-600 mb-6">
                    Are you sure you want to unsubscribe <strong>{email || 'this email'}</strong> from our newsletter?
                  </p>
                  <Button
                    onClick={handleUnsubscribe}
                    variant="outline"
                    className="text-red-600 border-red-200 hover:bg-red-50"
                    disabled={!email}
                    data-testid="confirm-unsubscribe-btn"
                  >
                    Yes, Unsubscribe Me
                  </Button>
                </>
              )}
            </CardContent>
          </Card>
        </div>
      </section>
    </Layout>
  );
};

export default UnsubscribePage;
